import {APP} from 'jsAssets/constants/app';
import _u from "jsAssets/utils/index";

// initial state
const state = {
    productQuantity: {},
};

// getters
const getters = {
    productQuantity: state => state.productQuantity,
};

// actions
const actions = {

};

// mutations
const mutations = {
    setProductQuantity (state, item) {
        state.productQuantity[item.id] = item.quantity;
    },

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
